import { ClickAwayListener } from "@mui/material";
import { useIsStorybook } from "utils/customHooks/storyHooks";

/** ClickAwayListener doesn't work in storybook */

export function ClickAwayListenerNS({ onClickAway, children, ...props }: any) {
  const isStorybook = useIsStorybook();
  return isStorybook ? (
    <>{children}</>
  ) : (
    <ClickAwayListener onClickAway={onClickAway} {...props}>
      {children}
    </ClickAwayListener>
  );
}
